import React from 'react';
import Link from 'next/link';
import { externalUrls, routes, socialUrls } from '@/constants/urls';
import HivemapperLogo from '../ui/icons/logo/HivemapperLogo';
import { P } from '../shadcn/typography';

const footerSections = [
  {
    title: 'Metrics',
    items: [
      {
        label: 'Coverage',
        href: routes.coverage,
      },
      {
        label: 'Contributors',
        href: routes.network.contributors,
      },
      {
        label: 'Regions',
        href: routes.network.regions,
      },
    ],
  },
  {
    title: 'Network',
    items: [
      {
        label: 'Documentation',
        href: externalUrls.hivemapperDocs,
        newTab: true,
      },
      {
        label: 'Privacy Policy',
        href: routes.privacy.privacyPolicy,
      },
      {
        label: 'Terms of Service',
        href: routes.tos,
      },
    ],
  },
  {
    title: 'Social Media',
    items: [
      {
        label: 'X',
        href: socialUrls.x,
        newTab: true,
      },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="flex w-full items-center justify-center bg-neutral-900 px-4 py-10 md:px-0">
      <div className="flex w-full max-w-xl justify-between">
        <div className="flex w-full flex-col gap-5 md:flex-row md:justify-between md:gap-40">
          <div className="flex w-fit shrink-0 grow flex-col items-start gap-6">
            <HivemapperLogo className="w-[130px] md:w-[212px]" />
            <P className="hidden text-2xs text-neutral-0 md:block md:text-2xs">
              Copyright © {new Date().getFullYear()} Hivemapper. All rights
              reserved.
            </P>
          </div>
          <div className="flex w-full grow-0 flex-row flex-wrap justify-between gap-y-5">
            {footerSections.map(section => (
              <div
                key={section.title}
                className="flex max-w-[170px] basis-1/2 flex-col gap-4 md:basis-1/3 md:gap-3">
                <P className="font-bold text-neutral-0">{section.title}</P>
                <ul className="flex flex-col gap-3 md:gap-1">
                  {section.items.map(item => (
                    <li key={item.label}>
                      <Link
                        href={item.href}
                        target={item.newTab ? '_blank' : '_self'}
                        className="text-sm text-neutral-400 hover:text-neutral-200">
                        <P className="text-neutral-300 hover:underline">
                          {item.label}
                        </P>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <P className="block text-2xs text-neutral-0 md:hidden">
            Copyright © {new Date().getFullYear()} Hivemapper. All rights
            reserved.
          </P>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
